
import {AcceptorOutputFn, andAcceptorSingle} from '../../../../models/acceptor/IAcceptor';
import {Acceptor_DcLED_LEDBuckBoost} from './dcLED_LEDBuckBoost_acceptor';
import {acceptSingle_common_Iout} from '../../../POWER/dcdc/acceptor/dcdc__common_acceptor';

export class Acceptor_DcLED_FloatingBuckBoost extends Acceptor_DcLED_LEDBuckBoost {

  constructor () {
    super();
  }

  protected singleOutputI(): AcceptorOutputFn {
    return acceptSingle_common_Iout;
  }

}
